module.exports = __webpack_public_path__ + "static/media/jackpots-lvl3.83e77039.png";